import ui from '@nuxt/ui/vue-plugin'
import { createPinia } from 'pinia'

import { createApp } from 'vue'

import App from './App.vue'
import router from './router'

import dayjs from '@/libs/dayjs'
import i18n from '@/libs/i18n'
import { createSentry } from '@/libs/sentry'

import '@/assets/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)
app.provide('dayjs', dayjs)
createSentry(app)
app.mount('#app')
